import { render, staticRenderFns } from "./zndetails.vue?vue&type=template&id=7cf24eb8&scoped=true"
import script from "./zndetails.vue?vue&type=script&lang=js"
export * from "./zndetails.vue?vue&type=script&lang=js"
import style0 from "./zndetails.vue?vue&type=style&index=0&id=7cf24eb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf24eb8",
  null
  
)

export default component.exports